// extracted by mini-css-extract-plugin
export default {"nav__item_active":"Nav_nav__item_active__atPQH","nav__item":"Nav_nav__item__ibnt2","nav":"Nav_nav__SOFW0","active":"Nav_active__uBvjG","nav__list":"Nav_nav__list__1ntQf"};